module.exports = __webpack_public_path__ + "static/img/step4.3d66e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howto/step4.png
// module id = Aqql
// module chunks = 1